import { CONTEXT_ROOT } from '../../utils'

const assetsPath = `${CONTEXT_ROOT}/assets`

export default {
  muli: {
    light: {
      fontFamily: 'Muli',
      src: `local(\'Muli Light\'), local(\'Muli-Light\'), url(https://fonts.gstatic.com/s/muli/v10/T-qN9Yh40TTJeenUALkjgg.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Muli-Light.ttf') format('truetype')`,
      fontWeight: '300',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'Muli',
      src: `local(\'Muli Regular\'), local(\'Muli-Regular\'), url(https://fonts.gstatic.com/s/muli/v10/z6c3Zzm51I2zB_Gi7146Bg.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Muli-Regular.ttf') format('truetype')`,
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'Muli',
      src: `local(\'Muli Bold\'), local(\'Muli-Bold\'), url(https://fonts.gstatic.com/s/muli/v10/WQIsflEaABH2ETkzZKPChw.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Muli-Bold.ttf') format('truetype')`,
      fontWeight: '700',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Muli',
      src: `local(\'Muli ExtraBold\'), local(\'Muli-ExtraBold\'), url(https://fonts.gstatic.com/s/muli/v10/uLHeTmQh-SODolEfROCiNQ.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Muli-ExtraBold.ttf') format('truetype')`,
      fontWeight: '800',
      fontStyle: 'normal'
    }
  },
  montserrat: {
    light: {
      fontFamily: 'Montserrat',
      src: `local(\'Montserrat Regular\'), local(\'Montserrat-Regular\'), url(https://fonts.gstatic.com/s/montserrat/v10/zhcz-_WihjSQC0oHJ9TCYPk_vArhqVIZ0nv9q090hN8.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Montserrat-Regular.ttf') format('truetype')`,
      fontWeight: '400',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'Montserrat',
      src: `local(\'Montserrat Regular\'), local(\'Montserrat-Regular\'), url(https://fonts.gstatic.com/s/montserrat/v10/zhcz-_WihjSQC0oHJ9TCYPk_vArhqVIZ0nv9q090hN8.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Montserrat-Regular.ttf') format('truetype')`,
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'Montserrat',
      src: `local(\'Montserrat SemiBold\'), local(\'Montserrat-SemiBold\'), url(https://fonts.gstatic.com/s/montserrat/v10/q2OIMsAtXEkOulLQVdSl06VlZKEoJGujTpfWnQT9bUY.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Montserrat-SemiBold.ttf') format('truetype')`,
      fontWeight: '600',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Montserrat',
      src: `local(\'Montserrat SemiBold\'), local(\'Montserrat-SemiBold\'), url(https://fonts.gstatic.com/s/montserrat/v10/q2OIMsAtXEkOulLQVdSl06VlZKEoJGujTpfWnQT9bUY.woff2) format(\'woff2\'), url('${assetsPath}/fonts/Montserrat-SemiBold.ttf') format('truetype')`,
      fontWeight: '600',
      fontStyle: 'normal'
    }
  },
  sourceSans: {
    light: {
      fontFamily: 'Source Sans Pro',
      src: `local(\'Source Sans Pro\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/ODelI1aHBYDBqgeIAH2zlNV_2ngZ8dMf8fLgjYEouxg.woff2) format(\'woff2\'), url('${assetsPath}/fonts/SourceSansPro-Regular.ttf') format('truetype')`,
      fontWeight: '400',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'Source Sans Pro',
      src: `local(\'Source Sans Pro\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/ODelI1aHBYDBqgeIAH2zlNV_2ngZ8dMf8fLgjYEouxg.woff2) format(\'woff2\'), url('${assetsPath}/fonts/SourceSansPro-Regular.ttf') format('truetype')`,
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'Source Sans Pro',
      src: `local(\'Source Sans Pro Semibold\'), local(\'SourceSansPro-Semibold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/toadOcfmlt9b38dHJxOBGCOFnW3Jk0f09zW_Yln67Ac.woff2) format(\'woff2\'), url('${assetsPath}/fonts/SourceSansPro-Semibold.ttf') format('truetype')`,
      fontWeight: '600',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Source Sans Pro',
      src: `local(\'Source Sans Pro Semibold\'), local(\'SourceSansPro-Semibold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/toadOcfmlt9b38dHJxOBGCOFnW3Jk0f09zW_Yln67Ac.woff2) format(\'woff2\'), url('${assetsPath}/fonts/SourceSansPro-Semibold.ttf') format('truetype')`,
      fontWeight: '600',
      fontStyle: 'normal'
    }
  },
  timSans: {
    light: {
      fontFamily: 'TIM Sans',
      src: `local(\'timsans-light\'), local(\'timsans-light\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-light.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-light.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-light.eot?#iefix) format('embedded-opentype'), url('${assetsPath}/fonts/timsans-light.woff') format('woff'), url('${assetsPath}/fonts/timsans-light.ttf') format('truetype'), url('${assetsPath}/fonts/timsans-light.eot?#iefix') format('embedded-opentype')`,
      fontWeight: '300',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'TIM Sans',
      src: `local(\'timsans-regular\'), local(\'timsans-regular\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-regular.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-regular.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-regular.eot?#iefix) format('embedded-opentype'), url('${assetsPath}/fonts/timsans-regular.woff') format('woff'), url('${assetsPath}/fonts/timsans-regular.ttf') format('truetype'), url('${assetsPath}/fonts/timsans-regular.eot?#iefix') format('embedded-opentype')`,
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'TIM Sans',
      src: `local(\'timsans-bold\'), local(\'timsans-bold\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-bold.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-bold.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-bold.eot?#iefix) format('embedded-opentype'), url('${assetsPath}/fonts/timsans-bold.woff') format('woff'), url('${assetsPath}/fonts/timsans-bold.ttf') format('truetype'), url('${assetsPath}/fonts/timsans-bold.eot?#iefix') format('embedded-opentype')`,
      fontWeight: '700',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'TIM Sans',
      src: `local(\'timsans-heavy\'), local(\'timsans-heavy\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-heavy.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-heavy.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-heavy.eot?#iefix) format('embedded-opentype'), url('${assetsPath}/fonts/timsans-heavy.woff') format('woff'), url('${assetsPath}/fonts/timsans-heavy.ttf') format('truetype'), url('${assetsPath}/fonts/timsans-heavy.eot?#iefix') format('embedded-opentype')`,
      fontWeight: '800',
      fontStyle: 'normal'
    }
  }
}



// WEBPACK FOOTER //
// ./styles/settings/fontfaces.js